import axios from 'axios';
import BigNumber from 'bignumber.js';
import { PS_API_URL } from '../hooks';
import { ICoin } from '../reducers/tradingReducer';

interface IBuildSwapTxArgs {
  base: ICoin;
  quote: ICoin;
  network: any;
  slippage: number;
  userAddress: string;
  priceRoute: any;
}

/**
 * @type number as string
 */
type NumberAsString = string;
/**
 * @type ethereum address
 */
type Address = string;
interface BuildTxBody {
  srcToken: Address;
  destToken: Address;
  srcAmount: NumberAsString;
  destAmount?: NumberAsString;
  priceRoute: any;
  userAddress: Address;
  partner?: string;
  partnerAddress?: string;
  partnerFeeBps?: string;
  receiver?: Address;
  srcDecimals?: number;
  destDecimals?: number;
  side: SwapSide;
  ignoreChecks: boolean;
  slippage: number;
}

export enum SwapSide {
  BUY = 'BUY',
  SELL = 'SELL',
}

const buildSwapTransaction = async ({
  base,
  quote,
  network,
  slippage,
  userAddress,
  priceRoute,
}: IBuildSwapTxArgs) => {
  const srcAmount = new BigNumber(base.amount)
    .times(10 ** base.decimals)
    .toFixed(0);

  const params: BuildTxBody = {
    srcToken: base.address,
    destToken: quote.address,
    srcDecimals: base.decimals,
    destDecimals: quote.decimals,
    srcAmount,
    userAddress,
    priceRoute,
    side: SwapSide.SELL,
    partner: 'kattana',
    partnerAddress: '0x3E2fa2A037444D76A99eaE6654Cd4EAB049bb5f7',
    partnerFeeBps: '20',
    ignoreChecks: false, // checks allowance!
    slippage: Math.ceil(Number(slippage * 100)),
  };

  const pricesURL = `${PS_API_URL}/transactions/${network}`;

  try {
    const { data } = await axios.post(pricesURL, params);

    return {
      data,
      error: null,
    };
  } catch (err: any) {
    if (err.response?.data?.error) {
      return {
        data: null,
        error: err.response?.data?.error,
      };
    } else {
      console.warn('[buildSwapTransaction]', err);
      return {
        data: null,
        error: 'Internal error',
      };
    }
  }
};

export { buildSwapTransaction };
